import { Typography } from '@mui/material';
import PublicToolLayout from '../../components/public-tools/PublicToolLayout';
import ToolWidget from '../../components/public-tools/ToolWidget';

export default function RobotsTxtValidatorPage() {
  return (
    <PublicToolLayout title="robots.txt Validator">
      <Typography variant="h5" fontWeight={700} gutterBottom>
        robots.txt Validator
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Enter your website URL to check whether robots.txt is accessible, syntactically correct, and
        contains a Sitemap directive.
      </Typography>
      <ToolWidget
        scanType="ROBOTS"
        formLabel="Website URL"
        formPlaceholder="https://example.com"
      />
    </PublicToolLayout>
  );
}
